export { default as ProductsIndexTableRowProductRenderType } from './ProductsIndexTableRowProductRenderType';
